import { Component, OnInit, ViewEncapsulation , ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/services/toast.service';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { SubscriptionService } from '../services/subscription.service';
import { catchError, of } from 'rxjs';
import { MainDowngradeService } from '../subscription-downgrade/services/main-downgrade.service';

@Component({
    selector: 'app-payment-success',
    templateUrl: './payment-success.component.html',
    styleUrls: ['./payment-success.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PaymentSuccessComponent implements OnInit {
  paymentDetails: any = {};
  loading: boolean = true;
  userId: number | string;
  userEmail: string;
  userFullName: string;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private toasterService: ToastService,
    private currentUserService: CurrentUserService,
    private subscriptionService: SubscriptionService,
    private downgradeService: MainDowngradeService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.setUpCurrentUser();
    this.getPaymentDetails();
  }

  setUpCurrentUser() {
    this.currentUserService.currentUser.subscribe((res) => {
      if (res) {
        this.userId = res.id;
        this.userEmail = res.email;
        this.userFullName = res.first_name + ' ' + res.last_name;
        this.updateDowngradeStatus();
        this.cdr.detectChanges();
      }
    });
  }

  updateDowngradeStatus() {
    this.downgradeService.loadDowngradeStatus(this.userId, true);
  }

  getPaymentDetails() {
    this.route.queryParams.subscribe(params => {
      if (params['session_id']) {
        this.paymentDetails.sessionId = params["session_id"];
        this.cdr.detectChanges();
      }

      // Stripe-hosted flow: immediately send user to Customer Portal to manage their plan.
      this.redirectToPortalWhenReady();
    });
  }

  private redirectToPortalWhenReady() {
    if (!this.userId) {
      // wait for currentUser observable to populate, then retry shortly
      setTimeout(() => this.redirectToPortalWhenReady(), 300);
      return;
    }

    this.subscriptionService
      .redirectToCustomPortal(this.userId)
      .pipe(catchError(() => of(null)))
      .subscribe((res: any) => {
        const url = res?.portal_url;
        if (url) {
          window.location.href = url;
          return;
        }
        // Fallback: if portal session cannot be created, send user back to subscription page.
        this.loading = false;
        this.cdr.detectChanges();
        this.toasterService.showSuccess(
          'Subscription updated. Use Manage Billing to access the portal.',
          'success',
        );
        this.router.navigate(['/subscription'], { queryParams: { isUser: true } });
      });
  }

  goToSubscription() {
    this.router.navigate(['/subscription'], { queryParams: { isUser: true } });
  }

  goToDashboard() {
    this.router.navigate(['/home']);
  }
} 